export const AGG_LEVEL = {
	REGIONS: "regions",
	PORTFOLIOS: "portfolios",
	STATIONS: "stations",
	DUIDS: "duids"
};

export const AGG_LEVELS = [{
	"value": AGG_LEVEL.REGIONS,
	'text': "Region"
},{
	"value": AGG_LEVEL.PORTFOLIOS,
	"text": "Portfolio"
},{
	"value": AGG_LEVEL.STATIONS,
	"text": "Station"
},{
	"value": AGG_LEVEL.DUIDS,
	"text": "Duid"
}];

export const AGG_LEVEL_ITEM_KEY = {
	[AGG_LEVEL.REGIONS]: "regionid",
	[AGG_LEVEL.PORTFOLIOS]: "portfolioid",
	[AGG_LEVEL.STATIONS]: "stationid",
	[AGG_LEVEL.DUIDS]: "duid_name"
};

export const SELECTOR_TYPE = {
	SERVICES: "services",
	VARIABLES: "variables",
	OBJECTS: "objects",
};

export const REQUEST_STATUS = {
	LOADING: "LOADING",
	ERROR: "ERROR",
	SUCCESS: "SUCCESS"
};




// WEBPACK FOOTER //
// ./src/views/reports/_utils/constants.js